import { Component } from 'react';
import './App.css';
import categories from './categories.json';
import Categories from './Categories';
import Header from './Header';
import Gallery from './Gallery';
import About from './About';
import Footer from './Footer';

export default class App extends Component{
  constructor(props){
    super();
    this.state = {
      selected: 'Home'
    }
  }
  changeCat = (cat) => {
    this.setState({ selected: cat });
  }
  render(){
    const now = new Date();
    const year = now.getFullYear();
    return (
      <div className="App">
        <Header />
        <div className="container">
          <Categories changeCat={this.changeCat} selected={this.state.selected} />
          <Gallery selected={this.state.selected} />
          <About />
        </div>
        <Footer year={year} />
      </div>
    );
  }
}
